import { IMG } from "@/data/site";

export const Browser = ({ url, children, className = "" }) => (
  <div className={`overflow-hidden rounded-xl border border-black/10 bg-white shadow-[0_40px_80px_-40px_rgba(7,13,31,0.55)] ${className}`}>
    <div className="flex items-center gap-1.5 border-b border-black/5 bg-slate-50 px-3 py-2">
      <span className="h-2 w-2 rounded-full bg-[#ff5f57]" /><span className="h-2 w-2 rounded-full bg-[#febc2e]" /><span className="h-2 w-2 rounded-full bg-[#28c840]" />
      <span className="ml-2 flex-1 truncate rounded bg-white px-2 py-0.5 text-[9px] text-slate-400">{url}</span>
    </div>
    <div className="aspect-[16/10] overflow-hidden">{children}</div>
  </div>
);

export const Phone = ({ children, className = "" }) => (
  <div className={`overflow-hidden rounded-[1.6rem] border-[5px] border-night bg-night shadow-[0_30px_60px_-20px_rgba(7,13,31,0.7)] ${className}`}>
    <div className="mx-auto my-1 h-1 w-10 rounded-full bg-white/20" />
    <div className="aspect-[9/18] overflow-hidden rounded-[1.15rem] bg-white">{children}</div>
  </div>
);

const Img = ({ src, className }) => <img src={src.replace("w=1200", "w=600")} alt="" loading="lazy" width="300" height="200" className={`h-full w-full object-cover ${className || ""}`} />;

const Bar = () => (
  <div className="flex h-full flex-col bg-[#f4ebe0] text-[#2a1a10]">
    <div className="flex justify-between px-4 py-2.5 text-[8px] font-semibold"><span className="font-serif text-[11px] italic">Caffè Aurora</span><span className="flex gap-3"><span>Menu</span><span>Orari</span><span>Prenota</span></span></div>
    <div className="grid flex-1 grid-cols-2 gap-3 px-4 pb-4">
      <div className="flex flex-col justify-center"><p className="font-serif text-[18px] leading-[1.05]">Colazioni lente, caffè fatto bene.</p><span className="mt-2 w-fit rounded-full bg-[#2a1a10] px-2.5 py-1 text-[7px] text-white">Vedi il menu</span></div>
      <div className="overflow-hidden rounded-lg"><Img src={IMG.bar} /></div>
    </div>
  </div>
);

const Salon = () => (
  <div className="flex h-full flex-col bg-[#0e0d0c] text-[#e9dcc4]">
    <div className="flex justify-between px-4 py-2.5 text-[8px] tracking-[0.25em]"><span>ATELIER</span><span>TRATTAMENTI · LISTINO</span></div>
    <div className="relative flex-1"><Img src={IMG.parrucchieri} className="opacity-60" />
      <div className="absolute inset-0 flex flex-col justify-end p-4"><p className="font-serif text-[18px] italic leading-tight">L’arte del colore.</p><span className="mt-2 w-fit border border-[#e9dcc4]/60 px-2.5 py-1 text-[7px] tracking-[0.2em]">PRENOTA</span></div>
    </div>
  </div>
);

const Fashion = () => (
  <div className="flex h-full flex-col bg-white text-black">
    <div className="flex justify-between border-b px-4 py-2 text-[8px] font-bold uppercase"><span>NOVA—STORE</span><span>Donna · Uomo · Nuovi arrivi</span></div>
    <p className="px-4 pt-2 text-[22px] font-black uppercase leading-none tracking-tight">SS / Collezione</p>
    <div className="grid flex-1 grid-cols-3 gap-1.5 p-3">
      {[0, 1, 2].map((i) => <div key={i} className="flex flex-col"><div className="flex-1 overflow-hidden bg-neutral-100"><Img src={IMG.abbigliamento} className={i === 1 ? "scale-150" : i === 2 ? "scale-125 object-left" : ""} /></div><p className="mt-1 text-[7px]">Capo {i + 1} · disponibile</p></div>)}
    </div>
  </div>
);

const Shop = () => (
  <div className="flex h-full flex-col bg-[#ede6d6] text-[#2f3a22]">
    <div className="flex justify-between px-4 py-2.5 text-[8px] font-semibold"><span className="font-serif text-[11px]">La Bottega</span><span>Storia · Prodotti · Valori</span></div>
    <div className="grid flex-1 grid-cols-[1.2fr_1fr] gap-3 px-4 pb-4">
      <div className="overflow-hidden rounded-[40px_6px_40px_6px]"><Img src={IMG.botteghe} /></div>
      <div className="flex flex-col justify-center"><p className="text-[7px] uppercase tracking-[0.2em] text-[#7a6a3a]">Dal territorio</p><p className="font-serif text-[16px] leading-tight">Prodotti scelti, uno per uno.</p><span className="mt-2 w-fit rounded bg-[#2f3a22] px-2 py-1 text-[7px] text-[#ede6d6]">Catalogo</span></div>
    </div>
  </div>
);

const Showroom = () => (
  <div className="flex h-full flex-col bg-[#1c1c1a] text-[#f2efe9]">
    <div className="flex justify-between border-b border-white/10 px-4 py-2.5 text-[8px] uppercase tracking-[0.2em]"><span>Forma Interni</span><span>Collezioni · Materiali</span></div>
    <div className="grid flex-1 grid-cols-[1fr_1.4fr]">
      <div className="flex flex-col justify-end p-4"><p className="text-[16px] font-light leading-tight">Spazi che durano nel tempo.</p><p className="mt-2 border-t border-white/20 pt-1.5 text-[7px] text-white/60">Richiedi preventivo →</p></div>
      <Img src={IMG.showroom} />
    </div>
  </div>
);

const Craft = () => (
  <div className="flex h-full flex-col bg-white text-slate-900">
    <div className="flex items-center justify-between px-4 py-2.5 text-[8px] font-bold"><span>FERRI & LEGNO</span><span className="rounded bg-[#f97316] px-2 py-0.5 text-white">Sopralluogo</span></div>
    <div className="relative mx-4 h-[45%] overflow-hidden rounded-md"><Img src={IMG.artigiani} /></div>
    <div className="grid flex-1 grid-cols-3 gap-1.5 p-4">
      {["Serramenti", "Arredi su misura", "Riparazioni"].map((t) => <div key={t} className="rounded border-l-2 border-[#f97316] bg-slate-50 p-1.5 text-[7px] font-semibold">{t}</div>)}
    </div>
  </div>
);

const SalonPhone = () => (
  <div className="h-full bg-[#0e0d0c] text-[#e9dcc4]">
    <div className="h-[42%]"><Img src={IMG.parrucchieri} /></div>
    <div className="p-3"><p className="text-[7px] tracking-[0.25em]">ATELIER · ESEMPIO</p><p className="mt-1 font-serif text-[14px] italic">Listino</p>
      {["Taglio", "Colore", "Piega"].map((t, i) => <div key={t} className="mt-1.5 flex justify-between border-b border-white/10 pb-1 text-[8px]"><span>{t}</span><span>da {30 + i * 15} €</span></div>)}
      <div className="mt-3 border border-[#e9dcc4]/50 py-1 text-center text-[7px] tracking-[0.2em]">RICHIEDI APPUNTAMENTO</div>
    </div>
  </div>
);

export const MOCKUPS = { bar: Bar, parrucchieri: Salon, abbigliamento: Fashion, botteghe: Shop, showroom: Showroom, artigiani: Craft };
export const MOCK_URLS = { bar: "caffe-aurora.esempio.it", parrucchieri: "atelier.esempio.it", abbigliamento: "nova-store.esempio.it", botteghe: "labottega.esempio.it", showroom: "forma-interni.esempio.it", artigiani: "ferrielegno.esempio.it" };
export { SalonPhone };
